import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
`;

export const Connector = styled.div`
  position: absolute;
  top: 10px;
  left: calc(-50% + 16px);
  right: calc(50% + 16px);
  border-top: 3px solid
    ${(props) =>
      props.active || props.completed
        ? props.theme.colors.darkblue
        : '#eaeaf0'};
  border-radius: 1px;
`;

export const IconWrapper = styled.div`
  color: ${(props) =>
    props.active || props.completed
      ? props.theme.colors.darkblue
      : '#eaeaf0'};
  display: flex;
  height: 22px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: ${(props) => props.theme.colors.card};
  padding: 0 4px;
`;

export const Circle = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: currentColor;
`;

export const CheckIcon = styled.span`
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
  ::before {
    content: '✓';
  }
`;

export const Label = styled.span`
  margin-top: 8px;
  font-size: ${(props) => props.theme.fontSizes.xs};
  color: ${(props) => props.theme.colors.label};
  text-align: center;
`;
